export default {"src":"/_next/static/media/messenger.9e29aac0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};